import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { imageUrl } from "../../lib/format";
import { Switch } from "../../components/ui/switch";
import { toast } from "sonner";
import { MessageCircle, Trash2 } from "lucide-react";

const waLink = (a) => {
  let num = String(a.telephone || "").replace(/\D/g, "").replace(/^00/, "");
  if (num.length === 10) num = `225${num}`;
  const prenom = (a.nom || "").trim().split(/\s+/)[0];
  const text = `Bonjour${prenom ? ` ${prenom}` : ""}, c'est Le Dressing de Yoyo. Vous aviez aimé « ${a.product_nom} », qui a été vendue. Nous avons de nouvelles pièces qui pourraient vous plaire, souhaitez-vous les découvrir ?`;
  return `https://wa.me/${num}?text=${encodeURIComponent(text)}`;
};

export default function AdminAlerts() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/alerts").then((r) => setItems(Array.isArray(r.data) ? r.data : []));
  useEffect(() => { load(); }, []);

  const setTraite = async (a, v) => { await api.put(`/admin/alerts/${a.id}`, { traite: v }); load(); };
  const remove = async (a) => {
    if (!window.confirm("Supprimer cette demande ?")) return;
    await api.delete(`/admin/alerts/${a.id}`);
    toast.success("Demande supprimée");
    load();
  };

  return (
    <div>
      <h1 className="font-serif text-3xl font-medium text-[#2C1A14]">Demandes « Prévenez-moi » <span className="text-base text-[#9B7E73]">({items.length})</span></h1>
      <p className="mb-6 mt-1 text-sm text-[#9B7E73]">Clientes qui veulent être prévenues d'une pièce similaire à un article vendu.</p>
      <div className="space-y-3">
        {items.map((a) => (
          <div key={a.id} data-testid={`alert-row-${a.id}`} className={`flex flex-col gap-3 rounded-xl bg-white p-4 ring-1 ring-[#E8D5CE] sm:flex-row sm:items-center sm:gap-4 ${a.traite ? "opacity-60" : ""}`}>
            <div className="flex min-w-0 flex-1 items-center gap-3">
            <img src={imageUrl(a.product_image, 320)} alt="" className="h-14 w-12 shrink-0 rounded object-cover" />
            <div className="min-w-0 flex-1">
              <p className="truncate font-medium text-[#2C1A14]">{a.product_nom}</p>
              <p className="text-sm text-[#6E544A]">{a.nom || "Cliente"} · {a.telephone}</p>
              <p className="text-xs text-[#9B7E73]">{a.created_at ? new Date(a.created_at).toLocaleDateString("fr-FR") : ""}{a.product_taille ? ` · Taille ${a.product_taille}` : ""}</p>
            </div>
            </div>
            <div className="flex items-center gap-3">
            <a href={waLink(a)} target="_blank" rel="noopener noreferrer" data-testid={`alert-wa-${a.id}`} className="flex items-center gap-1.5 rounded-full bg-[#25D366] px-4 py-2 text-sm font-medium text-white hover:bg-[#1EBE5A]">
              <MessageCircle className="h-4 w-4" /> Recontacter
            </a>
            <label className="flex items-center gap-2 text-xs text-[#6E544A]">
              <Switch checked={!!a.traite} onCheckedChange={(v) => setTraite(a, v)} data-testid={`alert-traite-${a.id}`} /> Traité
            </label>
            <button onClick={() => remove(a)} data-testid={`alert-delete-${a.id}`} className="rounded p-2 text-red-500 hover:bg-red-50"><Trash2 className="h-4 w-4" /></button>
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="rounded-xl bg-white p-8 text-center text-[#9B7E73] ring-1 ring-[#E8D5CE]">Aucune demande pour l'instant.</p>}
      </div>
    </div>
  );
}
